const checkStrVar = (variable: string | undefined, name: string): string => {
  if (!variable) throw new Error(`undefined variable: ${name}`);
  return variable;
};

const BACKEND_URL_BASE = checkStrVar(
  process.env.REACT_APP_BACKEND_URL_BASE,
  'REACT_APP_BACKEND_URL_BASE',
);
const PUBLIC_URL = checkStrVar(
  process.env.REACT_APP_PUBLIC_URL,
  'REACT_APP_PUBLIC_URL',
);

const CALLBACK_URL = PUBLIC_URL + '/callback';
const BACKEND_PATHS = {
  OAUTH_TOKEN_URL: BACKEND_URL_BASE + '/oauth/token',
  CREDENTIAL_OFFER: BACKEND_URL_BASE + '/credential-issuance',
  ISSUANCE_NOTIFICATION: BACKEND_URL_BASE + '/notify-issuance',
  WALLET_USER: BACKEND_URL_BASE + '/wallet/user/:document',
  REVOKE_CREDENTIALS: BACKEND_URL_BASE + '/revoke-credentials',
};

export { BACKEND_URL_BASE, PUBLIC_URL, CALLBACK_URL, BACKEND_PATHS };
